import { render, staticRenderFns } from "./editActivitiesView.vue?vue&type=template&id=36d5b9a0"
import script from "./editActivitiesView.vue?vue&type=script&lang=js"
export * from "./editActivitiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports